<template>
  <div>
    <div v-if="!dataReady || loading || loadingBuffer" class="col-12 pt-5 mt-5">
      <div class="text-center">
        <ChatLoadingDots :variant="darkMode ? 'dark' : ''" class="mt-5" />
      </div>
    </div>

    <div v-if="dataReady && !loading && !loadingBuffer">
      <div class="row">
        <div class="col-12">
          <div class="card chat-card bg-white">
            <div
              v-if="
                fullActiveChatComputed &&
                ((fullActiveChatComputed.responding_company && fullActiveChatComputed.responding_company.name) ||
                  (fullActiveChatComputed.originating_company && fullActiveChatComputed.originating_company.name) ||
                  toCompanyName)
              "
              class="card-header text-center bg-white pl-2 pr-2 pt-2 pb-0 mb-1"
            >
              <h5 class="font-weight-bold">
                <div v-if="userChatSide == 'originating'">
                  {{ toCompanyName ? toCompanyName : fullActiveChatComputed.responding_company.name }}
                  <span v-if="showCompanyOnlineStatus && otherPersonOnline(toCompanyId ? toCompanyId : fullActiveChatComputed.responding_company.id)">
                    <span class="online-status online" />
                    <span class="text-muted" style="font-size: 9px; font-weight: 300; margin: -2px 0 0 12px; position: absolute">
                      (In Chat Now)
                    </span>
                  </span>
                </div>

                <div v-if="userChatSide == 'responding'">
                  {{ fromCompany && fromCompany.name ? fromCompany.name : fullActiveChatComputed.originating_company.name }}
                  <span
                    v-if="showCompanyOnlineStatus && otherPersonOnline(fromCompanyId ? fromCompanyId : fullActiveChatComputed.originating_company.id)"
                  >
                    <span class="online-status online" />
                    <span class="text-muted" style="font-size: 9px; font-weight: 300; margin: -2px 0 0 12px; position: absolute">
                      (In Chat Now)
                    </span>
                  </span>
                </div>
              </h5>
            </div>

            <div class="card-body p-2 m-0">
              <div v-if="fullActiveChatComputed && messages && messages.length > 0">
                <div id="dialog_container">
                  <InfiniteLoading
                    v-if="isInitialLoaded"
                    spinner="spiral"
                    identifier="chat_drop_down"
                    direction="top"
                    @distance="1"
                    @infinite="infiniteHandler"
                  >
                    <template #spinner>
                      <div v-if="messages && messages.length > 20" class="current-user-company-text ghost">
                        <div class="d-block m-2 message-container">
                          <div class="pt-1 pb-0 pl-2 pr-2 text-small mb-1 message-time">
                            <span>
                              <span>
                                <span>
                                  <span>
                                    <span style="opacity: 0.3"> Loading </span>
                                  </span>
                                </span>
                              </span>
                            </span>
                          </div>
                          <div class="text-message-container no-attachment">
                            <div class="pt-2 pb-2 pl-2 pr-2 text-sm font-weight-normal text-message text-left">
                              <i class="fas fa-circle-notch fa-spin" style="opacity: 0.7" />
                            </div>
                            <div class="clearfix" />
                          </div>
                          <!---->
                          <span class="msg-author text-small float-right pr-1" style="opacity: 0.3"> Loading More Chats </span>
                        </div>
                        <div class="clearfix" />
                      </div>

                      <!--
                      <ChatLoadingDots
                        class="mt-3 mb-2"
                        :variant="darkMode ? 'dark' : ''"
                      />
                      -->
                    </template>

                    <template #no-more>
                      <!-- No more message -->
                    </template>
                    <template #no-results>
                      <!-- No results message -->
                    </template>
                  </InfiniteLoading>

                  <div
                    v-for="(message, index) in messages"
                    :key="index"
                    :class="chatForCurrentCompany(message) ? 'current-user-company-text' : 'other-user-company-text'"
                  >
                    <div class="d-block m-2 message-container">
                      <div class="pt-1 pb-0 pl-2 pr-2 text-small mb-1 message-time">
                        <span v-if="showQuickDeliveredStatus">
                          <span v-if="!chatForCurrentCompany(message)">
                            <!-- Left :: Thier Message -->
                            <span v-if="showDeliveredReadReceived">
                              <span v-if="userChatSide == 'originating'">
                                <span v-if="message.seen_by_responding_company"> Read </span>
                                <span v-if="!message.seen_by_responding_company"> Received </span>
                              </span>
                              <span v-if="userChatSide == 'responding'">
                                <span v-if="message.seen_by_originating_company"> Read </span>
                                <span v-if="!message.seen_by_originating_company"> Received </span>
                              </span>
                            </span>
                            <span v-if="!showDeliveredReadReceived"> Received </span>
                            {{ relative(message.created_at) }}
                          </span>

                          <span v-if="chatForCurrentCompany(message)">
                            <!-- Right :: My/Current User Messages -->
                            <span v-if="showDeliveredReadSent">
                              <span v-if="userChatSide == 'originating'">
                                <span v-if="message.seen_by_responding_company"> Seen </span>
                                <span v-if="!message.seen_by_responding_company"> Delivered </span>
                              </span>
                              <span v-if="userChatSide == 'responding'">
                                <span v-if="message.seen_by_originating_company"> Seen </span>
                                <span v-if="!message.seen_by_originating_company"> Delivered </span>
                              </span>
                              {{ relative(message.updated_at) }}
                            </span>

                            <span v-if="!showDeliveredReadSent">
                              {{ relative(message.updated_at) }}
                            </span>
                          </span>
                        </span>
                      </div>

                      <div
                        class="text-message-container"
                        :class="
                          message && message.message && message.message_attachments && message.message_attachments.length > 0
                            ? 'has-attachment'
                            : 'no-attachment'
                        "
                      >
                        <div v-if="message && message.message_attachments && message.message_attachments.length > 0">
                          <div v-for="attachment in message.message_attachments" :key="attachment.id">
                            <div v-if="attachment.type == 'invoice-link'" class="message-invoices-container">
                              <div class="message-invoice-item">
                                <div class="invoice-logo">
                                  <img
                                    :src="industry == 'cannabis' ? '/img/logos/icon-apex.svg' : '/img/logos/icon-bushel.svg'"
                                    :alt="industry == 'cannabis' ? 'Apex Logo' : 'Bushel44 Logo'"
                                  />
                                </div>
                                <div class="message-invoice-content">
                                  <div class="message-invoice-name btn-link clickable" @click="navToInvoice(attachment.meta)">
                                    {{ attachment.name }}
                                    <span v-if="attachment.meta.order_data" class="text-small">
                                      ({{ dateLocal(attachment.meta.order_data.order_date) }})
                                    </span>
                                  </div>
                                  <div class="message-invoice-link">
                                    <!-- {{ appName }} -->
                                    <!-- {{ attachment.meta.link }} -->
                                    {{ displayNameForLink() }}
                                  </div>
                                </div>
                              </div>
                              <div class="clearfix" />
                            </div>

                            <!-- v-if="attachment.type == 'image/jpeg'" -->
                            <img v-else :src="attachment.attachmentLink" :alt="attachment.name" class="img-fluid text-message-image" />
                            <div class="clearfix" />
                          </div>
                        </div>
                        <div v-if="message && message.message" class="pt-2 pb-2 pl-2 pr-2 text-sm font-weight-normal text-message">
                          <span v-html-safe="messageFilter(message.message)" />
                        </div>
                        <div class="clearfix" />
                      </div>

                      <div v-if="showDeliveredSent" class="pt-1 pb-0 pl-2 pr-2 text-small font-weight-normal seen-message">
                        <span class="message-time">
                          <span v-if="!chatForCurrentCompany(message)">
                            <span v-if="userChatSide == 'originating'">
                              <span v-if="message.seen_by_responding_company"> Read </span>
                              <span v-if="!message.seen_by_responding_company"> Received </span>
                            </span>
                            <span v-if="userChatSide == 'responding'">
                              <span v-if="message.seen_by_originating_company"> Read </span>
                              <span v-if="!message.seen_by_originating_company"> Received </span>
                            </span>
                          </span>

                          <span v-if="chatForCurrentCompany(message)">
                            <span v-if="userChatSide == 'originating'">
                              <span v-if="message.seen_by_responding_company"> Seen </span>
                              <span v-if="!message.seen_by_responding_company"> Delivered </span>
                            </span>
                            <span v-if="userChatSide == 'responding'">
                              <span v-if="message.seen_by_originating_company"> Seen </span>
                              <span v-if="!message.seen_by_originating_company"> Delivered </span>
                            </span>
                            {{ timeLocalized(message.updated_at) }}
                          </span>
                        </span>
                      </div>

                      <span
                        v-if="showMessageAuthor && message && message.user && message.user.name"
                        class="msg-author text-small"
                        :class="chatForCurrentCompany(message) ? 'float-right pr-1' : 'float-left pl-1'"
                      >
                        From {{ message.user.name }}
                      </span>
                    </div>

                    <div class="clearfix" />
                    <div :id="'message_end_' + message.uuid" class="clearfix" :style="index == messages.length - 1 ? '' : ''" />
                  </div>

                  <div
                    v-if="activeParticipant"
                    :class="user.current_company_id == activeParticipant.current_company_id ? 'float-right d-none' : 'float-left'"
                  >
                    <ChatLoadingDots class="ml-2 mt-1 mb-2 mr-2" :variant="darkMode ? 'dark' : ''" />
                  </div>
                  <!-- <br><br> -->
                  <div class="clearfix" />
                </div>
              </div>

              <div v-else>
                <p class="p-4 mt-3 text-primary">No Chats Messages <i class="far fa-comment-dots" /></p>
              </div>
            </div>
            <NewChatMessage
              :initial-chat-message="initialChatMessage"
              :disabled="disabledDialog"
              :submitting="submittingDialog"
              :error="errorDialog"
              :submitted="submittedDialog"
              :loading="loadingDialog"
              :clear-dialog="clearDialog"
              :invoices-available="invoicesAvailable"
              :invoices-loaded="invoicesLoaded"
              :loading-invoices="loadingInvoices"
              :dark-mode="darkMode"
              @keydown="isTyping"
              @send-message="sendMessage"
            />
          </div>
        </div>

        <div v-if="showParticipants" class="col-12">
          <div class="card shadow-none border border-0">
            <p class="card-header pb-1 pt-2 pl-2 pr-2 bg-white text-nowrap text-center text-sm font-weight-normal">Online Participants</p>
            <div class="card-body p-0" style="overflow: hidden">
              <ul class="list-group list-group-flush">
                <li
                  v-for="(participant, index) in participants"
                  :key="index"
                  class="list-group-item small"
                  :class="activeParticipant && activeParticipant.id && activeParticipant.id == participant.id ? 'bg-light' : ''"
                >
                  <span class="text-nowrap">
                    <img :src="participant.avatarLink" class="logo mr-1" style="width: 100%; max-width: 20px; border-radius: 5px" />
                    {{ participant.name }}
                    <i
                      class="far fa-keyboard fa-fw fa-xs"
                      style="line-height: 1"
                      :class="activeParticipant && activeParticipant.id && activeParticipant.id == participant.id ? 'text-muted' : 'text-white'"
                    />
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// ;
import { mapActions } from "vuex";
// import VueChatScroll from "vue-chat-scroll";
import "linkify-plugin-hashtag/dist/linkify-plugin-hashtag.mjs";
import "linkify-plugin-mention/dist/linkify-plugin-mention.mjs";
import linkifyHtml from "linkify-html";
import InfiniteLoading from "@/components/common/InfiniteScrolling.vue";
import * as api from "@/services/api";
import * as websockets from "@/services/websockets";
import ChatLoadingDots from "@/components/chat/ChatLoadingDots.vue";
import NewChatMessage from "@/components/chat/NewChatMessage.vue";
import { navTo } from "@/services/helpers";
import { relative, timeLocalized, dateLocal } from "@/services/filters";
// Vue.use(VueChatScroll);

export default {
  name: "ChatDialog",
  components: { ChatLoadingDots, InfiniteLoading, NewChatMessage },
  props: {
    initialChatMessage: { type: String },
    user: { type: Object, required: true },
    activeChat: { type: Object, required: true },
    fullActiveChat: { type: Object, required: true },
    dataReady: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    showCompanyOnlineStatus: { type: Boolean, default: true },
    showParticipants: { type: Boolean, default: false },
    showDeliveredSent: { type: Boolean, default: false }, // Below Message
    showQuickDeliveredStatus: { type: Boolean, default: true }, // Above Message
    showDeliveredReadReceived: { type: Boolean, default: false }, // Above Message Option (Show Read)
    showDeliveredReadSent: { type: Boolean, default: true }, // Above Message Option (Show Seen)
    showMessageAuthor: { type: Boolean, default: true },
    invoicesAvailable: {
      type: Array,
      default() {
        return [];
      },
    },
    invoicesLoaded: { type: Boolean, default: false },
    loadingInvoices: { type: Boolean, default: false },
    darkMode: { type: Boolean, default: false },
    toCompanyId: { type: Number, default: null },
    toCompanyUuid: { type: String, default: null },
    toCompanyName: { type: String, default: null },
    fromCompanyId: { type: Number, default: null },
    fromCompany: { type: Object, default: null },
  },
  emits: ["messagesUpdated"],
  data() {
    return {
      industry: APP_INDUSTRY,
      appName: APP_NAME,
      messages: [],
      participants: [],
      activeParticipant: false,
      newMessage: null,
      typingTimer: false,
      loadingDialog: false,
      submittingDialog: false,
      disabledDialog: false,
      errorDialog: false,
      submittedDialog: false,
      chatChannelName: null,
      clearDialog: false,
      vueScrollConfig: {
        enabled: false,
        always: true,
        smooth: true,
        scrollonremoved: true,
        smoothonremoved: true,
        notSmoothOnInit: true,
      },
      isInitialLoaded: false,
      messagesPage: 1,
      lastPage: 0,
      loadingBuffer: true,
    };
  },
  computed: {
    fullActiveChatComputed() {
      return this.fullActiveChat;
    },
    userChatSide() {
      if (this.fullActiveChatComputed) {
        if (
          this.fullActiveChatComputed.originating_company_id &&
          this.user.current_company_id &&
          this.user.current_company_id == this.fullActiveChatComputed.originating_company_id
        ) {
          return "originating";
        }
        if (
          this.fullActiveChatComputed.responding_company_id &&
          this.user.current_company_id &&
          this.user.current_company_id == this.fullActiveChatComputed.responding_company_id
        ) {
          return "responding";
        }
      }
      return null;
    },
  },
  watch: {
    async fullActiveChatComputed(newVal, oldVal) {
      const self = this;
      if (newVal != oldVal) {
        self.vueScrollConfig.enabled = false;
        await self.markAsRead();
        self.setupLazyMessages();
        // Adjust for images in roll
        setTimeout(() => {
          self.scrollToLastMessage();
        }, 500);
      }
    },
    userChatSide(newVal, oldVal) {
      // this.markAsRead();
    },
    messages(newVal, oldVal) {
      // this.scrollToLastMessage('smooth');
    },
  },
  created() {},
  async mounted() {
    const self = this;
    window.addEventListener("resize", self.onResizeListener);
    await self.initChat();
    await self.runChatListener();
  },
  beforeUnmount() {
    window.Echo.leave(this.chatChannelName);
    window.removeEventListener("resize", this.onResizeListener);
  },
  methods: {
    ...mapActions({
      setSnackbar: "ui/setSnackbar",
    }),
    navTo,
    relative,
    timeLocalized,
    dateLocal,
    async initChat() {
      this.chatChannelName = `chat.${this.activeChat.uuid}`;
      await this.setupLazyMessages();
      await this.markAsRead();
    },
    async setupLazyMessages(refreshing = false) {
      const self = this;
      self.messagesPage = 1;
      self.messages = [];
      // self.loadingBuffer = true;
      if (self.fullActiveChatComputed && self.fullActiveChatComputed.chat_messages && self.fullActiveChatComputed.chat_messages.length > 0) {
        self.messages = self.fullActiveChatComputed.chat_messages.reverse();
      } else {
        self.messages = self.fullActiveChatComputed.chat_messages;
      }
      if (self.fullActiveChatComputed && self.fullActiveChatComputed.uuid) {
        await self.fetchMessages(refreshing).then((response) => {
          self.lastPage = response.data.last_page;
          self.messages = response.data.data.reverse();
          self.scrollToLastMessage();
          setTimeout(() => {
            self.isInitialLoaded = true;
            self.vueScrollConfig.enabled = true;
            self.loadingBuffer = false;
            // Adjust for images in roll
            self.scrollToLastMessage();
            setTimeout(() => {
              self.scrollToLastMessage();
            }, 1000);
          }, 1000);
        });
      }
    },
    fetchMessages(refreshing = false) {
      const url = this.isInitialLoaded
        ? `/company-chat/active-chat-messages/${this.fullActiveChatComputed.uuid}?page=${this.messagesPage}`
        : `/company-chat/active-chat-messages/${this.fullActiveChatComputed.uuid}`;
      return api.get(url);
    },
    infiniteHandler($state) {
      const self = this;
      setTimeout(() => {
        if (self.isInitialLoaded) {
          self.vueScrollConfig.enabled = false;
          self.fetchMessages().then((response) => {
            self.lastPage = response.data.last_page;
            if (response.data.data.length > 0) {
              response.data.data.forEach((message) => {
                const exists = self.messages.find((msg) => msg.id == message.id);
                if (!exists) {
                  self.messages.unshift(message);
                }
              });
              if (self.messagesPage - 1 === self.lastPage) {
                self.messagesPage = 2;
                $state.complete();
              } else {
                self.messagesPage += 1;
              }
              $state.loaded();
            } else {
              self.messagesPage = 2;
              $state.complete();
            }
          });
        }
      }, 1000);
    },
    runChatListener() {
      const self = this;
      window.Echo.join(self.chatChannelName)
        .here((user) => {
          self.participants = user;
        })
        .joining((user) => {
          self.participants.push(user);
        })
        .leaving((user) => {
          self.participants = self.participants.filter((u) => u.id != user.id);
        })
        .listen("ChatMessageSent", (event) => {
          if (self.messages && self.messages.length > 0) {
            const exists = self.messages.find((message) => message.id == event.chatMessage.id);
            // Prevent array duplication.
            if (exists) {
              self.messages.map((obj) => [exists].find((o) => o.id === obj.id) || obj);
            } else {
              self.messages.push(event.chatMessage);
            }
            self.vueScrollConfig.enabled = true;
            self.scrollToLastMessage("smooth", 300);
          }
          self.markAsRead(event.chatMessage);
        })
        .listen("ChatMessagesRead", (event) => {
          if (event && event.messages) {
            self.updateMessages(event.messages);
          }
        })
        .listenForWhisper("typing", (user) => {
          self.activeParticipant = user;
          if (self.typingTimer) {
            clearTimeout(self.typingTimer);
          }
          self.typingTimer = setTimeout(() => {
            self.activeParticipant = false;
          }, 1000);
        });
    },
    updateMessages(messagesIn = []) {
      const self = this;
      if (messagesIn.length > 0) {
        messagesIn.forEach((updatedMessage, updatedMessageIndex) => {
          const existingMessage =
            self.messages && self.messages.length > 0 ? self.messages.find((message) => message.id == updatedMessage.id) : false;
          if (existingMessage) {
            existingMessage.seen_by_originating_company = updatedMessage.seen_by_originating_company;
            existingMessage.seen_by_responding_company = updatedMessage.seen_by_responding_company;
            existingMessage.updated_at = updatedMessage.updated_at;
          }
        });
        self.$emit("messagesUpdated", messagesIn);
      }
    },
    async markAsRead(msg = null) {
      const self = this;
      const data = {
        chatUuid: self.activeChat.uuid,
        msgUuid: msg && msg.uuid ? msg.uuid : null,
        side: self.userChatSide,
      };
      await api.post("company-chat/message-read", data).then(
        (response) => {
          if (response && response.data && response.data.code == 200 && response.data.data && response.data.data.messages) {
            self.updateMessages(response.data.data.messages);
          } else {
            self.setSnackbar({ variant: "danger", title: "Error", message: "Error marking message as read" });
          }
        },
        (error) => {
          self.setSnackbar({ variant: "danger", title: "Error", message: "Error marking message as read" });
        },
      );
    },
    async sendMessage(incoming) {
      const self = this;
      const originatingCompanyId = self.fullActiveChatComputed.originating_company_id;
      const respondingCompanyId = self.fullActiveChatComputed.responding_company_id;
      self.newMessage = incoming.message;
      self.errorDialog = false;
      self.submittedDialog = true;
      self.submittingDialog = true;
      const newMessage = {
        user_id: self.user.id,
        chat_room_id: self.fullActiveChatComputed.id,
        originating_company_id: originatingCompanyId,
        responding_company_id: respondingCompanyId,
        message: self.newMessage,
        attachments: {
          images: incoming.images,
          invoices: incoming.invoices,
        },
      };
      if (
        (self.newMessage == null || self.newMessage == "") &&
        incoming.images &&
        incoming.images.length <= 0 &&
        incoming.invoices &&
        incoming.invoices.length <= 0
      ) {
        self.errorDialog = true;
      } else {
        await api.post("company-chat/send-message", newMessage).then(
          (response) => {
            if (
              response &&
              response.data &&
              response.data.code == 202 &&
              response.data.data &&
              response.data.data.message &&
              response.data.data.message.id
            ) {
              if (self.messages && self.messages.length > 0) {
                const exists = self.messages.find((message) => message.id == response.data.data.message.id);
                // Prevent array duplication.
                if (exists) {
                  self.messages.map((obj) => [exists].find((o) => o.id === obj.id) || obj);
                } else {
                  self.messages.push(response.data.data.message);
                }
                self.scrollToLastMessage("smooth");
              }
              self.newMessage = null;
              self.clearDialog = true;
            } else {
              self.setSnackbar({ variant: "danger", title: "Error", message: "Error sending chat message" });
            }
          },
          (error) => {
            self.setSnackbar({ variant: "danger", title: "Error", message: "Error sending chat message" });
          },
        );
      }
      self.clearDialog = false;
      self.submittingDialog = false;
    },
    async isTyping(val) {
      const self = this;
      self.activeParticipant = self.user;
      if (self.typingTimer) {
        clearTimeout(self.typingTimer);
      }
      self.typingTimer = setTimeout(() => {
        self.activeParticipant = false;
      }, 800);
      // let channel = window.Echo.private(self.chatChannelName);
      const channel = window.Echo.join(self.chatChannelName);
      setTimeout(() => {
        channel.whisper("typing", self.user);
      }, 300);
    },
    otherPersonOnline(companyId) {
      if (this.participants) {
        if (this.participants.find((participant) => participant.current_company_id == companyId)) {
          return true;
        }
      }
      return false;
    },
    chatForCurrentCompany(message) {
      return message.user.current_company_id == this.user.current_company_id;
    },
    scrollToMessage(uuid, delay = 300, trans = null) {
      let el = null;
      const idKey = `message_end_${uuid}`;
      setTimeout(() => {
        el = document.getElementById(idKey);
        if (el) {
          if (trans) {
            el.scrollIntoView({
              behavior: trans,
              block: "end",
              inline: "end",
            });
          } else {
            el.scrollIntoView({
              block: "end",
              inline: "end",
            });
          }
        }
      }, delay);
    },
    scrollToLastMessage(trans = null, delay = 300) {
      if (this.messages && this.messages.length > 0) {
        const lastMessage = this.messages[this.messages.length - 1];
        this.scrollToMessage(lastMessage.uuid, delay, trans);
      }
    },
    onResizeListener() {
      // If within a certian pixel distance from the bottom of thediv showing then refocus on window resize
      const el = document.getElementById("dialog_container");
      if (el) {
        if (el.scrollHeight - el.scrollTop - el.clientHeight < 300) {
          this.scrollToLastMessage("smooth");
        }
      }
    },
    displayNameForLink() {
      return window.location.host;
      // return this.appName;
    },
    navToInvoiceLink(data) {
      let link = null;
      if (data && data.order_data && data.order_data.seller_company_id && this.user.current_company_id == data.order_data.seller_company_id) {
        link = data.link_seller;
      }
      if (data && data.order_data && data.order_data.buyer_company_id && this.user.current_company_id == data.order_data.buyer_company_id) {
        link = data.link_buyer;
      }
      return link;
    },
    navToInvoice(data, newWindow = true) {
      const link = this.navToInvoiceLink(data);
      if (link) {
        if (newWindow) {
          const routeData = this.$router.resolve({ path: link });
          window.open(routeData.href, "_blank");
        } else {
          this.navTo(link);
        }
      }
    },
    messageFilter(message = null) {
      if (message == null || message == "") {
        return false;
      }
      // https://soapbox.github.io/linkifyjs/docs/options.html
      return linkifyHtml(message.toString().replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;"), {
        attributes: {
          rel: "nofollow",
          // title: 'Open in new window',
        },
        defaultProtocol: "https",
        nl2br: false,
        tagName: "a",
        // target: {
        //   url: '_blank',
        //   hashtag: '_blank',
        //   email: '_blank',
        // },
        target: "_blank",
        validate: true,
        ignoreTags: ["script", "style"],
        className: {
          url: "chat-message--link chat-message--url",
          email(href) {
            return "chat-message--link chat-message--email";
          },
          hashtag: "chat-message--link chat-message--hashtag",
          mention: "chat-message--link chat-message--mention",
        },
        formatHref(href, type) {
          let url = href;
          if (type === "hashtag") {
            url = `https://twitter.com/hashtag/${href.substring(1)}`;
          }
          if (type === "mention") {
            url = `https://twitter.com/${href.substring(1)}`;
          }
          return url;
        },
      });
    },
  },
};
</script>

<style scoped>
::-webkit-scrollbar {
  width: 10px;
}
::-webkit-scrollbar-track {
  background: #eeeeee;
  cursor: pointer;
  border-radius: 10px;
}
::-webkit-scrollbar-thumb {
  background: #d1d1d1;
  border-radius: 10px;
}
::-webkit-scrollbar-thumb:hover {
  background: #c1c1c1;
}
:deep(.chat-message--link) {
  color: inherit;
  opacity: 0.95;
  text-decoration: underline;
}
:deep(.chat-message--link:hover) {
}
:deep(.current-user-company-text .chat-message--link) {
}
:deep(.current-user-company-text .chat-message--link:hover) {
}
:deep(.message-send-container) {
}
:deep(.chat-card .message-send-container) {
}
</style>

<style lang="scss" scoped>
@import "@sass/_variables.scss";
@import "@sass/_mixins.scss";
.chat-card {
  border-radius: 5px;
  border: 2px solid $charCardBorderColor;
  box-shadow: none;
  .card-header {
    border-bottom: 3px solid $charCardBorderColor;
  }
}
.card-body #dialog_container {
  height: 55vh;
  overflow: hidden;
  overflow-y: auto;
}
.message-container {
  width: 100%;
  max-width: 50%;
  .message-time {
    font-weight: 400;
    color: $messageFloatingColor;
  }
  .text-message-container {
    .text-message-image {
      width: 100%;
    }
    &.has-attachment {
      .text-message {
        @include border-radius(0 0 $chatMessagesBorderRadius $chatMessagesBorderRadius);
        margin-top: 1px;
      }
      .text-message-image {
        @include border-radius($chatMessagesBorderRadius $chatMessagesBorderRadius 0 0);
      }
    }
    &.no-attachment {
      .text-message {
        @include border-radius($chatMessagesBorderRadius);
      }
      .text-message-image {
        @include border-radius($chatMessagesBorderRadius);
      }
    }
  }
  .seen-message {
    color: $messageFloatingColor;
    font-weight: 300;
    font-size: 10px;
  }
}
.current-user-company-text {
  .message-container {
    float: right;
    .message-time {
      text-align: right;
    }
    .text-message {
      background-color: $currentUserChatMessagesBgColor;
      color: $currentUserChatMessagesTextColor;
    }
    .seen-message {
      text-align: right;
    }
  }
  &.ghost {
    .message-container {
      .text-message {
        background-color: lighten($currentUserChatMessagesBgColor, 20%);
        color: $currentUserChatMessagesTextColor;
      }
    }
  }
}
.other-user-company-text {
  .message-container {
    float: left;
    .message-time {
      text-align: left;
    }
    .text-message {
      background-color: $otherUserChatMessagesBgColor;
      color: $otherUserChatMessagesTextColor;
    }
    .seen-message {
      text-align: left;
    }
  }
}
.online-status {
  position: absolute;
  margin: -2px -2px 0 0;
  content: "";
  display: inline-block;
  height: 10px;
  width: 10px;
  border-radius: 50%;
  &.online {
    background: $onlineStatusBgColor;
  }
}
.msg-author {
  color: darken($messageFloatingColor, 1%);
}
.message-invoices-container {
  cursor: default;
  width: 100%;
  display: block;
  padding: 10px;
  background: $newChatMessageBgColor;
  border: 2px solid $newChatMessageBorderColor;
  .message-invoice {
  }
  .message-invoice-item {
    width: 100%;
    position: relative;
    .invoice-logo {
      width: 50px;
      float: right;
      img {
        width: 100%;
        max-width: 40px;
        margin: 0;
        position: absolute;
        right: 0;
      }
    }
    .message-invoice-content {
      width: calc(100% - 50px);
      float: left;
      .message-invoice-name {
        font-weight: 600;
        color: $primary;
        font-size: 14px;
      }
      .message-invoice-link {
        color: $grey-400;
        font-size: 0.8em;
      }
    }
  }
}
.has-attachment {
  .message-invoices-container {
    border-radius: 10px;
    @include border-radius(10px 10px 0 0);
  }
}
.no-attachment {
  .message-invoices-container {
    @include border-radius(10px);
  }
}
</style>
